const passwordResetValidation = () => {

    document.addEventListener("DOMContentLoaded", () => {
        const form = document.querySelector(".rc_lost_reset_password");
        if (!form) return;

        const password1 = form.querySelector("#password_1");
        const password2 = form.querySelector("#password_2");
        const submitBtn = form.querySelector('button[type="submit"]');
        const loader = form.querySelector(".wc-loader");
        if (!password2) return;

        const showInputError = (input, message) => {
            let errorEl = input.nextElementSibling;
            if (errorEl && errorEl.classList.contains("input-error")) {
                errorEl.remove();
            }
            if (message) {
                input.classList.add("wpcf7-not-valid");
                const div = document.createElement("div");
                div.className = "input-error";
                div.style.color = "red";
                div.style.fontSize = "0.9em";
                div.style.marginTop = "5px";
                div.textContent = message;
                input.parentNode.insertBefore(div, input.nextSibling);
            } else {
                input.classList.remove("wpcf7-not-valid");
            }
        };

        const validatePassword = (password) => {
            if (/[а-яёА-ЯЁ]/.test(password)) {
                return rcTranslate.password_no_cyrillic || rcTranslate.password_must;
            }


            if (password.length < 8) {
                return rcTranslate.password_long;
            }


            if (!/(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>_])/.test(password)) {
                return rcTranslate.password_contain;
            }

            return "";
        };

        [password1, password2].forEach(input => {
            input.addEventListener("input", () => {
                showInputError(input, "");
                submitBtn.disabled = false;
                if (loader) loader.style.display = "none";
            });
        });

        form.addEventListener("submit", (e) => {
            let hasError = false;

            if (!password1.value.trim()) {
                showInputError(password1, rcTranslate.enterNewPassword);
                hasError = true;
            } else {
                const passError = validatePassword(password1.value.trim());
                if (passError) {
                    showInputError(password1, passError);
                    hasError = true;
                }
            }

            if (!password2.value.trim()) {
                showInputError(password2, rcTranslate.repeatNewPassword);
                hasError = true;
            }

            if (
                password1.value.trim() &&
                password2.value.trim() &&
                password1.value !== password2.value
            ) {
                const errorMsg = rcTranslate.password_not_match;
                showInputError(password1, errorMsg);
                showInputError(password2, errorMsg);
                hasError = true;
            }

            if (hasError) {
                e.preventDefault();
                submitBtn.disabled = true;
                if (loader) loader.style.display = "none";
                return;
            }

            if (loader) loader.style.display = "inline-block";
            submitBtn.disabled = true;
        });
    });
};

export default passwordResetValidation;
